import type { ReactElement } from 'react'

import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

export interface LoadingStateProps {
  /** Quantas linhas de esqueleto desenhar. */
  readonly linhas?: number
  readonly className?: string
  /** Texto lido por leitor de tela enquanto carrega. */
  readonly rotulo?: string
}

/**
 * Estado de carregamento. Um dos três estados obrigatórios da DoD: o painel
 * nunca mostra tela branca enquanto espera a API.
 */
export function LoadingState({
  linhas = 3,
  className,
  rotulo = 'Carregando…',
}: LoadingStateProps): ReactElement {
  const total = Math.max(1, linhas)
  const chaves = Array.from({ length: total }, (_, indice) => `linha-${String(indice)}`)

  return (
    <div role="status" aria-live="polite" aria-busy="true" className={cn('space-y-3', className)}>
      <span className="sr-only">{rotulo}</span>
      <Skeleton className="h-8 w-1/3" />
      {chaves.map((chave) => (
        <Skeleton key={chave} className="h-16 w-full" />
      ))}
    </div>
  )
}
